import {h} from "preact";
import FullSite from "./full-site";

export default function GenericPage({Component, path, ...props}) {
	return <FullSite>
		<div class="bg-white min-h-screen text-black max-w-screen">
			<Component key={path} {...props} />
		</div>
	</FullSite>
}